module.exports = __webpack_public_path__ + "img/UvBlack.cc1e4b75.svg";